import React from 'react';
import { Trophy, TrendingUp, TrendingDown } from 'lucide-react';

export const TechnicianLeaderboard = ({ 
  scores = [], 
  onTechnicianClick,
  title = "Top Texniklər",
  headerBgClass = "bg-primary"
}) => {
  return (
    <div className="bg-white rounded-lg border border-zinc-200 overflow-hidden">
      <div className={`${headerBgClass} p-4`}>
        <h2 className="text-2xl font-bold uppercase tracking-tight text-white flex items-center gap-2" data-testid="leaderboard-title">
          <Trophy className="h-6 w-6" />
          {title}
        </h2>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-zinc-100 border-b border-zinc-200">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-bold text-zinc-700 uppercase tracking-wider">Sıra</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-zinc-700 uppercase tracking-wider">Texnik</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Xal</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Tamamlanmış</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Geri qaytarılmış</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Gecikmiş</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-zinc-200">
            {scores.map((score, index) => (
              <tr 
                key={score.technician_id} 
                className={`${index < 3 ? 'bg-yellow-50' : ''} hover:bg-zinc-100 cursor-pointer transition-colors`}
                data-testid={`technician-row-${score.technician_id}`}
                onClick={() => onTechnicianClick?.(score.technician_id, score.technician_full_name || score.technician_name)}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    {index === 0 && <Trophy className="h-5 w-5 text-yellow-500 mr-2" />}
                    {index === 1 && <Trophy className="h-5 w-5 text-zinc-400 mr-2" />}
                    {index === 2 && <Trophy className="h-5 w-5 text-amber-600 mr-2" />}
                    <span className="font-bold text-zinc-900">{index + 1}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="font-semibold text-primary hover:underline" data-testid={`tech-name-${score.technician_id}`}>
                    {score.technician_full_name || score.technician_name}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex items-center justify-center gap-1">
                    {score.score > 0 ? (
                      <TrendingUp className="h-4 w-4 text-green-600" />
                    ) : (
                      <TrendingDown className="h-4 w-4 text-red-600" />
                    )}
                    <span className={`text-xl font-bold font-mono ${
                      score.score > 0 ? 'text-green-600' : 'text-red-600'
                    }`} data-testid={`tech-score-${score.technician_id}`}>
                      {score.score > 0 ? '+' : ''}{score.score}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="text-green-600 font-semibold" data-testid={`tech-completed-${score.technician_id}`}>
                    {score.completed_tickets}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="text-red-600 font-semibold" data-testid={`tech-rejected-${score.technician_id}`}>
                    {score.rejected_tickets}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="text-yellow-600 font-semibold" data-testid={`tech-delayed-${score.technician_id}`}>
                    {score.delayed_tickets}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TechnicianLeaderboard;
